import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import { FaQuoteLeft, FaStar, FaStarHalfAlt } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
    
    {
        review: "Rask levering og bærene var perfekt modne. Anbefales!",
        name: "Marius Haugen",
        rating: 4.5,
    },
    {
        review: "Elsker at de tilbyr gratis frakt over 249kr. Bærene smakte fantastisk.",
        name: "Sara Østby",
        rating: 5,
    },
    {
        review: "Jeg har aldri smakt så gode jordbær før! Kjempefornøyd.",
        name: "Henrik Johansen",
        rating: 4.5,
    },
    {
        review: "Veldig fornøyd med kvaliteten på bærene. Kommer garantert til å bestille igjen!",
        name: "Linda Sørensen",
        rating: 5,
    }
];


const TestimonialSection = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: "ease-in-out",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };


    return (
        <div className="container">
            <h1 className="section-title">Hva Våre Kunder Sier</h1>
            <div className="section-border"></div>
            <Container>
                <StyledSlider {...settings}>
                    {testimonials.map((testimonial, index) => (
                        <TestimonialCard key={index}>
                            <QuoteIcon>
                                <FaQuoteLeft size={30} />
                            </QuoteIcon>
                            <ReviewText>"{testimonial.review}"</ReviewText>
                            <Divider />
                            <div>

                            <Author>{testimonial.name}</Author>
                            <Stars>
                                {Array.from({ length: 5 }, (_, i) => {
                                    if (testimonial.rating >= i + 1) {
                                        return <FaStar key={i} />;
                                    } else if (testimonial.rating > i) {
                                        return <FaStarHalfAlt key={i} />;
                                    } else {
                                        return <FaStar key={i} style={{ opacity: 0.3 }} />;
                                    }
                                })}
                            </Stars>
                            </div>
                        </TestimonialCard>
                    ))}
                </StyledSlider>
            </Container>
        </div>
    )
}

export default TestimonialSection

const Section = styled.section`
    width: 100%;
    background: #f9f9f9;
    padding: 4rem 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Container = styled.div`
    max-width: 1200px;
    width: 100%;
    text-align: center;
    margin: 0 auto;
`;

const Divider = styled.div`
    width: 60px;
    height: 4px;
    background: #d32f2f;
    margin: 0.5rem auto 2rem;
`;

const StyledSlider = styled(Slider)`
    .slick-slide {
        padding: 0 10px;
    }

    .slick-prev, .slick-next {
        color: #2d6a4f !important;
    }

    .slick-prev::before, .slick-next::before {
        color: #2d6a4f !important;
        font-size: 30px;
    }

    .slick-dots {
        bottom: -35px;
    }

    @media (max-width: 768px) {
        .slick-prev, .slick-next {
            display: none !important;
        }
    }
`;

const TestimonialCard = styled.div`
    background: white;
    padding: 2rem;
    border-radius: 5px;
    text-align: center;
    transition: all 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 350px;

    &:hover {
        transform: scale(1.05);
    }

    > div:last-child {
        margin-top: auto;
    }
`;

const QuoteIcon = styled.div`
    color: #d32f2f;
    margin-bottom: 1rem;
`;

const ReviewText = styled.p`
    font-size: 1rem;
    font-style: italic;
    color: #555;
    margin-bottom: 1rem;
`;

const Author = styled.h4`
    font-size: 1.1rem;
    font-weight: bold;
    color: #333;
    margin-top: 1rem;
`;

const Stars = styled.div`
    display: flex;
    gap: 5px;
    justify-content: center;
    margin-top: 0.5rem;
    color: #f4b400;
    font-size: 1.2rem;
`;